import { memoize } from "lodash";
import { observable } from "mobx";
import { apiCallGetAllUsersAIDescriptions } from "../../../api/developer-api/api-call-get-all-users-ai-descriptions";
import { TAllUsersAIDescriptionsData } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

const PAGE_LIMIT = 50;

class AIDescriptionsAllStore {
  rows = observable.box<TAllUsersAIDescriptionsData>([]);
  hasMore = observable.box<boolean>(true);

  getAllUsersAIDescriptions = async () => {
    getCoreUIStore().setIsLoading("DEVELOPER_AI_GENERATED_DESCRIPTION_ALL", true);
    const { status, data, code } = await apiCallGetAllUsersAIDescriptions({
      limit: PAGE_LIMIT,
      offset: 0
    });
    getCoreUIStore().setIsLoading(
      "DEVELOPER_AI_GENERATED_DESCRIPTION_ALL",
      false
    );
    if (status === "OK") {
      this.rows.set(data);
      this.hasMore.set(data.length === PAGE_LIMIT);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  loadMore = async () => {
    if (!this.hasMore.get()) {
      return;
    }
    getCoreUIStore().setIsLoading("DEVELOPER_AI_GENERATED_DESCRIPTION_ALL", true);
    const { status, data, code } = await apiCallGetAllUsersAIDescriptions({
      limit: PAGE_LIMIT,
      offset: this.rows.get().length
    });
    getCoreUIStore().setIsLoading(
      "DEVELOPER_AI_GENERATED_DESCRIPTION_ALL",
      false
    );
    if (status === "OK") {
      this.rows.set([...this.rows.get(), ...data]);
      this.hasMore.set(data.length === PAGE_LIMIT);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getAIDescriptionsAllStore = memoize(
  () => new AIDescriptionsAllStore(),
  () => 1
);
export default getAIDescriptionsAllStore;
